import * as React from "react";
import { Alert, AlertTitle, Button, Stack } from "@mui/material";

import { useCreateLeadFields, useMissingLeadFields } from "@/hooks/api/use-lead-finder";

/**
 * Offers to create the contact fields bought leads fill. A lead keeps every value either way, but the contacts
 * list only shows those with a field, so without them a company or an industry seems lost.
 */
export function LeadFieldsPrompt({ pluginId }: { pluginId: string }): React.JSX.Element | null {
	const { data: missing = [] } = useMissingLeadFields(pluginId);
	const create = useCreateLeadFields(pluginId);
	const [dismissed, setDismissed] = React.useState(false);
	if (dismissed || missing.length === 0) return null;
	return (
		<Alert
			severity="info"
			action={
				<Stack direction="row" spacing={1}>
					<Button color="inherit" size="small" onClick={() => setDismissed(true)} disabled={create.isPending}>
						Not now
					</Button>
					<Button
						color="inherit"
						size="small"
						variant="outlined"
						onClick={() => create.mutate()}
						disabled={create.isPending}
					>
						Create them
					</Button>
				</Stack>
			}
		>
			<AlertTitle>Create {missing.length} contact fields?</AlertTitle>
			ZoomInfo fills {missing.map(({ label }) => label).join(", ")}. Your contacts have no fields for them yet, so your
			contacts list would not show them.
		</Alert>
	);
}
